var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeneralActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 83.35 52.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-geral") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_3033135413456",
    "data-name": 3033135413456
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.07,49.54a64.7,64.7,0,0,1,7.27-.06h22l0-3.28L.06,46.13v3.41Z",
    transform: "translate(0 0)",
    fill: "#ed7333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.08,3.61V5.34H29.47l0-1.63V2.18C29,2,1.86,1.94,0,2.14A4.43,4.43,0,0,1,.08,3.61Z",
    transform: "translate(0 0)",
    fill: "#ed7333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.07,34.85a45.25,45.25,0,0,1,5.62-.07h5.68c3.6,0,7.86.2,11.37,0l-.06-.24V32l.06-.5L.06,31.43Z",
    transform: "translate(0 0)",
    fill: "#ed7333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.68 17.81 22.74 16.83 0.06 16.74 0.1 20.09 22.66 20.08 22.68 17.81",
    fill: "#ed7333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.28,29a19.72,19.72,0,0,0,.19-2.59,19.85,19.85,0,0,0-.19-2.59l5.58-4.36a1.33,1.33,0,0,0,.32-1.7L77.89,8.65a1.38,1.38,0,0,0-1.61-.59L69.7,10.71a19.37,19.37,0,0,0-4.47-2.59l-1-7A1.29,1.29,0,0,0,62.93,0H52.35a1.3,1.3,0,0,0-1.3,1.11l-1,7a20.51,20.51,0,0,0-4.47,2.59L39,8.06A1.59,1.59,0,0,0,38.52,8a1.3,1.3,0,0,0-1.14.66L32.1,17.79a1.31,1.31,0,0,0,.31,1.7L38,23.85a22.23,22.23,0,0,0-.18,2.59A22.08,22.08,0,0,0,38,29L32.41,33.4a1.33,1.33,0,0,0-.31,1.69l5.28,9.15a1.33,1.33,0,0,0,1.17.66,1.29,1.29,0,0,0,.45-.08l6.58-2.65a19.77,19.77,0,0,0,4.47,2.6l1,7a1.29,1.29,0,0,0,1.3,1.11H62.93a1.28,1.28,0,0,0,1.29-1.11l1-7a20.25,20.25,0,0,0,4.46-2.6l6.59,2.65a1.6,1.6,0,0,0,.47.08,1.32,1.32,0,0,0,1.14-.66l5.29-9.15a1.32,1.32,0,0,0-.32-1.69L77.28,29h0Zm-5.23-4.52a15.12,15.12,0,0,1,.13,1.93,19.23,19.23,0,0,1-.13,1.93l-.37,3L74,33.21l2.86,2.22L75,38.63l-3.36-1.35-2.75-1.11L66.55,38a15.49,15.49,0,0,1-3.3,1.93L60.44,41,60,44l-.53,3.56h-3.7L55.28,44l-.42-3-2.8-1.14A14.65,14.65,0,0,1,48.81,38L46.4,36.17l-2.8,1.14-3.36,1.35-1.85-3.2,2.86-2.22,2.35-1.85-.37-3c-.08-.82-.13-1.43-.13-2s0-1.14.13-1.93l.37-3-2.35-1.85-2.86-2.22,1.85-3.2L43.6,15.6l2.75,1.11,2.38-1.8A15.67,15.67,0,0,1,52,13l2.81-1.13.42-3,.53-3.57h3.67L60,8.86l.42,3L63.19,13a15,15,0,0,1,3.25,1.88l2.41,1.85,2.8-1.14L75,14.23l1.85,3.19L74,19.67l-2.35,1.85.37,3ZM57.64,15.87A10.58,10.58,0,1,0,68.21,26.44,10.57,10.57,0,0,0,57.64,15.87Zm0,15.86a5.29,5.29,0,1,1,5.29-5.29A5.3,5.3,0,0,1,57.64,31.73Z",
    transform: "translate(0 0)",
    fill: "#ed7333"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralActive);
export default __webpack_public_path__ + "static/media/generalActive.bd0fa28c507513acae67e3e1c8f7ce17.svg";
export { ForwardRef as ReactComponent };